import "../css/inputgroup.css";
import commoncss from "../css/common.module.css";
import {ReqFieldLabel} from "../../myfin_v2/components/mis";

export default function InputGroup({ req=false,label, inputs = [] ,icon="",iconLabel="", width,class_="",class2_="",group_width="",input_width=""}) {
      const inputStyle = {
      width: width || "initial",
    };
    const groupWidth = {
      width: width || "initial",
    };
    const inputWidth = {
      width: input_width || "initial",
    };

  return (
    <div className={`input-group-wrapper ${class_}`} style={inputStyle}>
      {label && <span className={`${req?'input-label':'input-group-label'}`}>{req&&(<ReqFieldLabel/>)}&nbsp;{label}<span className={commoncss.primaryLable}>{icon} {iconLabel}</span></span>}
      <div className={`input-group ${class2_}`} style={groupWidth}>
        {inputs.map((input, idx) => (
          <div className="input-col" style={inputWidth} key={idx}>
            {input}
          </div>
        ))}
      </div>
    </div>
  );
}
